window.PIB_STUDENT_DRIVE_DATA = [
  {
    "book": "Smart PBD AI_English",
    "year": "Year 4",
    "items": [
      {
        "title": "English Yr 4 (Answers)",
        "url": "https://drive.google.com/drive/folders/1th-CP4ezalNYg5Xx5MvvkVS_BGcNUHAO"
      },
      {
        "title": "AI Elements",
        "url": "https://drive.google.com/drive/folders/1Enoez6UioIE2IOR0pkKGIrNCH_7XDm0S"
      },
      {
        "title": "Audio",
        "url": "https://drive.google.com/drive/folders/1_q9u0wPjxwz1ul68SwiiG_WDaZumk0YK"
      }
    ]
  },
  {
    "book": "Smart PBD AI_English",
    "year": "Year 6",
    "items": [
      {
        "title": "English Yr 6 (Answers)",
        "url": "https://drive.google.com/drive/folders/1uWLkJBO8XUTRUnyS0X-5b3MHpAJ_NGLj"
      },
      {
        "title": "Audio",
        "url": "https://drive.google.com/drive/folders/1Wsh6Mgddf0LqOGHEl94EGuLZcD7ow0T1"
      },
      {
        "title": "AI Elements",
        "url": "https://drive.google.com/drive/folders/1rAsLIfE7ARs_0pvn8rZb9RioM998CWRu"
      }
    ]
  },
  {
    "book": "Smart PBD AI_English",
    "year": "Year 5",
    "items": [
      {
        "title": "English Yr 5 (Answers)",
        "url": "https://drive.google.com/drive/folders/1uHFFqbGmJc1zplq7_MRhAF02g8mPix91"
      },
      {
        "title": "Quiz",
        "url": "https://drive.google.com/drive/folders/11TKMgeYiqaHiK3DNq2wgQ0JFeKbh6-aP"
      },
      {
        "title": "Tutorial Videos",
        "url": "https://drive.google.com/drive/folders/1z0O5xFUkud3IEEzF891JA0j8L1jnXX_C"
      },
      {
        "title": "AI Elements",
        "url": "https://drive.google.com/drive/folders/1n3Vh8FWlAXYfMuTs5u8Xge5fwSuf7FVr"
      },
      {
        "title": "Audio",
        "url": "https://drive.google.com/drive/folders/17sI8JSyW9yY7O1D0atbyQq0BQno8kGKz"
      },
      {
        "title": "Extra Practices",
        "url": "https://drive.google.com/drive/folders/1WJXTnD3mYvWs_qG1LZmokamcWX2i0CQz"
      },
      {
        "title": "Teaching Video",
        "url": "https://drive.google.com/drive/folders/18GGGiUlsk1mLROSrvewZJ8tru0HcbLjT"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Mathematics (DLP)",
    "year": "Year 4",
    "items": [
      {
        "title": "Pembelajaran Abad ke-21 Activity",
        "url": "https://drive.google.com/drive/folders/1cR1qmUeVJn9ZalU2ZhiZvFUpDHmVMkWJ"
      },
      {
        "title": "Modul Teknologi Maklumat dan Komunikasi (TMK)",
        "url": "https://drive.google.com/drive/folders/1z-UU8AhlgN_P_T5OYbMtdau6jh0ZCD8y"
      },
      {
        "title": "Project-Based Learning",
        "url": "https://drive.google.com/drive/folders/1ZpAhDcXN01ETYwU7cOfxJoCWCykX5dqa"
      },
      {
        "title": "Extra Practice",
        "url": "https://drive.google.com/drive/folders/1qJjACBj_GNti3V7Fzk5hRQlFzCz9zr2s"
      },
      {
        "title": "Video",
        "url": "https://drive.google.com/drive/folders/1eLS7fRmuaGi-fzlbew14wHESiF2PiXHB"
      },
      {
        "title": "Website",
        "url": "https://drive.google.com/drive/folders/1Iq0BifVP7bbJKmkkztrX3PaFet-hwKRw"
      },
      {
        "title": "Quiz",
        "url": "https://drive.google.com/drive/folders/1ohuECB8v6hm2SYrIlJvmAAu4CJFqsfnA"
      },
      {
        "title": "e-book",
        "url": "https://drive.google.com/drive/folders/1yeEc1mCFx8vno6sXhBgBR83Lb_Dmzq3h"
      },
      {
        "title": "e-question",
        "url": "https://drive.google.com/drive/folders/1hcZe_8Zo-NZ2ksIbWaQ9LNmK4xHZo4M5"
      },
      {
        "title": "Teacher's Resource",
        "url": "https://drive.google.com/drive/folders/1g83b9BcPL2rjzq5QDRColOZtakNHe4aY"
      },
      {
        "title": "e-RPH",
        "url": "https://drive.google.com/drive/folders/1Ib1lVUiIu6Vq0Lp66_VjUu0N3jW_CQX7"
      },
      {
        "title": "Answers",
        "url": "https://drive.google.com/drive/folders/17anjFD9T3BCjsVtUI7sqG0IFYH-r5pxU"
      },
      {
        "title": "AI Elements",
        "url": "https://drive.google.com/drive/folders/1aaGlWVIJkd3Wsmf6gho0TGk0tTgTtv6S"
      },
      {
        "title": "PPT Notes",
        "url": "https://drive.google.com/drive/folders/1kZEVEQlRlILOKh_CrLZlP2k7D3daVlXS"
      },
      {
        "title": "Interactive Activity",
        "url": "https://drive.google.com/drive/folders/1xiF1qxrLfO4dBeC-v-5vYvi5JpI_TGIG"
      },
      {
        "title": "Solving Video",
        "url": "https://drive.google.com/drive/folders/1GKFDyslYYl3uOhvP2ouaLv-C6RxukgP9"
      },
      {
        "title": "Teaching Video",
        "url": "https://drive.google.com/drive/folders/1-ZMgUBQrBhZJD3paejPrMHGXH1psIN3b"
      },
      {
        "title": "Tutorial Video",
        "url": "https://drive.google.com/drive/folders/1IKy7jFbpJ9DB6kL6Y47Xd6gmMOL55bu_"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Mathematics (DLP)",
    "year": "Year 5",
    "items": [
      {
        "title": "Modul Teknologi Maklumat dan Komunikasi (TMK)",
        "url": "https://drive.google.com/drive/folders/1WOdusDiPz0IsfQb4TTXkypprLuEyQds1"
      },
      {
        "title": "Pembelajaran Abad ke-21 Activity",
        "url": "https://drive.google.com/drive/folders/1MuXfqeNkrNDhZx_MSwc-wodEuwRRWjmw"
      },
      {
        "title": "Project-Based Learning",
        "url": "https://drive.google.com/drive/folders/1b7W32FvLqJOKg5RBk9A_dQVlv4XF4OAp"
      },
      {
        "title": "Bonus (IFC)",
        "url": "https://drive.google.com/drive/folders/1a024v8MJxXLw_7ih3zuR_6c3RSC15ETu"
      },
      {
        "title": "Answers",
        "url": "https://drive.google.com/drive/folders/1dLsU0lknaTp2bmcqxJeuAhnOVUgDKTLG"
      },
      {
        "title": "Interactive Activity",
        "url": "https://drive.google.com/drive/folders/1QoapRMeObwHOo-zNIANKJ2jycIKhwACP"
      },
      {
        "title": "Website",
        "url": "https://drive.google.com/drive/folders/1pmApZHckxRBjeyRAGUkr_E13D2h5JYEd"
      },
      {
        "title": "Video",
        "url": "https://drive.google.com/drive/folders/1OuGAmsgFeUwN2fGT_spr47I1oGtgWRj1"
      },
      {
        "title": "Extra Practice",
        "url": "https://drive.google.com/drive/folders/1SRC8DYsk_1hJmEy-RsvBAfTwC1OLn--9"
      },
      {
        "title": "Tutorial Video",
        "url": "https://drive.google.com/drive/folders/1nQWtdF_g84fWgLKxj0TUJ4GrJa35ZKWN"
      },
      {
        "title": "E-Questions",
        "url": "https://drive.google.com/drive/folders/1Z33v-UFBEVqnI2Co33CLKT3FUxY-gPZq"
      },
      {
        "title": "PPT Notes",
        "url": "https://drive.google.com/drive/folders/1AycWAiJU2RFqAemTsWw_Ru3lboGOotgD"
      },
      {
        "title": "JSI Monthly Test 2",
        "url": "https://drive.google.com/drive/folders/1NnSU_i38sfoBlzRq5d8z-NFVUPmkrJcJ"
      },
      {
        "title": "JSI Monthly Test 1",
        "url": "https://drive.google.com/drive/folders/1c6BOiTIYqwTVW0tOeGj2Z9Jb9lcAR43w"
      },
      {
        "title": "AI Elements",
        "url": "https://drive.google.com/drive/folders/1eGXfCnG4eCK8YiLxLluyTdezfdzD-IZW"
      },
      {
        "title": "Solving Video",
        "url": "https://drive.google.com/drive/folders/105w07xexyzD3jwN6QI1xwpIM8Cu3n_qa"
      },
      {
        "title": "Teaching Video",
        "url": "https://drive.google.com/drive/folders/1yPCQfwBJ7vcKZfA1POvyfS6eU7sftQYn"
      },
      {
        "title": "Quiz",
        "url": "https://drive.google.com/drive/folders/16JSB_cUJAb5mpbJHWjG7Ykuu0iZZ7c1W"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Mathematics (DLP)",
    "year": "Year 6",
    "items": [
      {
        "title": "Pembelajaran Abad ke-21 Activity",
        "url": "https://drive.google.com/drive/folders/1pJY0piEbvFKx5e51JfeIBby3QmAqa83s"
      },
      {
        "title": "Modul Teknologi dan Komunikasi (TMK)",
        "url": "https://drive.google.com/drive/folders/1gh5DrE5ASADNa8ezgJSs7QVeosuZmnm9"
      },
      {
        "title": "Project-Based Learning",
        "url": "https://drive.google.com/drive/folders/1ynycpe0DHE-mnxA8xAy_QtqV_LV0pLfa"
      },
      {
        "title": "Bonus",
        "url": "https://drive.google.com/drive/folders/1obdayiVtVKyeEogwIlqx1XEqY__U7A19"
      },
      {
        "title": "Answers",
        "url": "https://drive.google.com/drive/folders/1s12hXGORi5yZy5P_IgK49wxehAlPz2PP"
      },
      {
        "title": "E-Questions",
        "url": "https://drive.google.com/drive/folders/1SQinM-l313jOb748dpojUHLXujJyOgcF"
      },
      {
        "title": "Interactive Activity",
        "url": "https://drive.google.com/drive/folders/1wmn6kkN29EbFo0OPiLk4vsjB7wUhIFme"
      },
      {
        "title": "Website",
        "url": "https://drive.google.com/drive/folders/1_dj2367gdDCf56UPQe5SCJ7o-HzEaNl1"
      },
      {
        "title": "Video",
        "url": "https://drive.google.com/drive/folders/1159_dFymOM3Eh3I6TdQKZnPxJtj6EQmG"
      },
      {
        "title": "Quiz",
        "url": "https://drive.google.com/drive/folders/1KTUWWNLfcwg4t3hfZWVUEm7IODhoFlY1"
      },
      {
        "title": "Extra Practice",
        "url": "https://drive.google.com/drive/folders/1KOTPSp2VNtyOjOeiW5TIbfe8xQSA0Uk-"
      },
      {
        "title": "PPT Notes",
        "url": "https://drive.google.com/drive/folders/12DyHgzlpZ-RxG4e9UfJb6SYjMceSmPVT"
      },
      {
        "title": "Solving Video",
        "url": "https://drive.google.com/drive/folders/1gBCZYH3zl7Kk0nqvw0TQelpJoZOIU_a2"
      },
      {
        "title": "Teaching Video",
        "url": "https://drive.google.com/drive/folders/1pLdeSoT4Dxcvi-IGQp6oRGRVlcVpfU3J"
      },
      {
        "title": "Tutorial Video",
        "url": "https://drive.google.com/drive/folders/1k0Dawq7YHkP0sMsV0vTj1TDxy0LXBcHx"
      },
      {
        "title": "AI Elements",
        "url": "https://drive.google.com/drive/folders/1vxzaRQuFwdUjdisHZQfvSLunoSve6gSs"
      },
      {
        "title": "JSI Monthly Test 2",
        "url": "https://drive.google.com/drive/folders/14M1g9zaAKau7y2niwHTdD3Smj-ZGYTnm"
      },
      {
        "title": "JSI Monthly Test 1",
        "url": "https://drive.google.com/drive/folders/1WD_xd6DSgLGNw634imC4uKkgrsRY09sg"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Science (DLP)",
    "year": "Year 6",
    "items": [
      {
        "title": "`IFC",
        "url": "https://drive.google.com/drive/folders/1IyldArfoxQMH2mxaPClmiWMgvSBUmukU"
      },
      {
        "title": "AI Elements",
        "url": "https://drive.google.com/drive/folders/1OHAQZ1iyAKuAQ043d6iybDAskEzkDNYK"
      },
      {
        "title": "Extra Practice",
        "url": "https://drive.google.com/drive/folders/1yVTM18hwZO1-iMY1XQEiXhsDH-xAqnl_"
      },
      {
        "title": "Tutorial Video",
        "url": "https://drive.google.com/drive/folders/19SF_NjbKtSu_49ykQO6cHbSIN0PW2d9V"
      },
      {
        "title": "Experiment Video",
        "url": "https://drive.google.com/drive/folders/1NWqht-Ge6P2Xpze7MLxg46oU2UUkE2QJ"
      },
      {
        "title": "Solving Video",
        "url": "https://drive.google.com/drive/folders/1Gvtonxcyv9BqtncRxH7IyCQ-sMOKxzQU"
      },
      {
        "title": "Video",
        "url": "https://drive.google.com/drive/folders/1SBpD7aMrju1cez7_8wH5yp3lBHjlfMIL"
      },
      {
        "title": "Website",
        "url": "https://drive.google.com/drive/folders/1yT2TUgzvmcH6bKp2lBf3zmAmuiAmtKY_"
      },
      {
        "title": "JSI Monthly Test 2",
        "url": "https://drive.google.com/drive/folders/1Z23rueIqwO0vBJwny4fcsvhxow6Gat7h"
      },
      {
        "title": "JSI Monthly Test 1",
        "url": "https://drive.google.com/drive/folders/1o8JiEMa-5lofrMVu5N7DQODa5xR9FpP5"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Science (DLP)",
    "year": "Year 5",
    "items": [
      {
        "title": "e-RPH",
        "url": "https://drive.google.com/drive/folders/1Kbzh0mnBCcEn7MJ5of2h-aAXk4_cGw82"
      },
      {
        "title": "Power Points Notes",
        "url": "https://drive.google.com/drive/folders/1Boe6DrP-myxYsrtCH9ussaXsapc9Z-Ro"
      },
      {
        "title": "e-Questions",
        "url": "https://drive.google.com/drive/folders/1F3wQUetmD2DU0i_tT-JTI3d3WI_HnCB2"
      },
      {
        "title": "E-Books",
        "url": "https://drive.google.com/drive/folders/19O-aIQHb3IoDa-Mf7osFAlcGFncUDnSB"
      },
      {
        "title": "PAK-21",
        "url": "https://drive.google.com/drive/folders/1tF7PyUU_1XCgwBUbzEvRnsK4iNyTCWgp"
      },
      {
        "title": "TMK",
        "url": "https://drive.google.com/drive/folders/1DT4krWdCZHlcjCm5pvLdrfDXsCuNDgKt"
      },
      {
        "title": "Teacher’s Resource",
        "url": "https://drive.google.com/drive/folders/1FiEgLwUyFPw2i4y_QBDkDqsXVTiIfNjp"
      },
      {
        "title": "Project-Based Learning",
        "url": "https://drive.google.com/drive/folders/16Lx_qxyT-IohW_pMSDB2K1SRG3hz7SRF"
      },
      {
        "title": "JSI",
        "url": "https://drive.google.com/drive/folders/18-7s0E63MB_wJ5ctynPtFJ4ff0Iw8wV1"
      },
      {
        "title": "Extra Practice",
        "url": "https://drive.google.com/drive/folders/1I9TyyH1dPrUVHrbnS_es0MgnVktcG74f"
      },
      {
        "title": "Experiment Video",
        "url": "https://drive.google.com/drive/folders/1-ECNLMX93O06t4xZvzxmoa95GOlBUpO9"
      },
      {
        "title": "Website",
        "url": "https://drive.google.com/drive/folders/1Ve5uw_meUZnsbDYZavccRgqaNKs7lq8I"
      },
      {
        "title": "AI Elements",
        "url": "https://drive.google.com/drive/folders/1ZzPG_S9h0MlYee55GRmZ6B1EHC_e83cY"
      },
      {
        "title": "Interactive Activity",
        "url": "https://drive.google.com/drive/folders/1RSO2XBKPY9Cu_5aJzFnB8ODwb44nI8mx"
      },
      {
        "title": "Solving Video",
        "url": "https://drive.google.com/drive/folders/1w7hov7DmIPsxuTeMwKlq5FPvudG3oBgB"
      },
      {
        "title": "Video",
        "url": "https://drive.google.com/drive/folders/1qWbHzV09_MDEoo1iG2VSl3bAIL-Nam5U"
      },
      {
        "title": "Tutorial Video",
        "url": "https://drive.google.com/drive/folders/1hx9G8oUqAP_Ac6E8ISaahbdeyfYi-P7Y"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Science (DLP)",
    "year": "Year 4",
    "items": [
      {
        "title": "AI Elements",
        "url": "https://drive.google.com/drive/folders/1sBQf3gU5kC4x9qUINWBBGSqqQumu09ph"
      },
      {
        "title": "Tutorial Video",
        "url": "https://drive.google.com/drive/folders/1KMXE0BcdLSZI1C8c8wKmWvH25Ykh_8wR"
      },
      {
        "title": "Experiment Video",
        "url": "https://drive.google.com/drive/folders/17CuNuXZ7QiBmkS958Op8rG45sddQy6AB"
      },
      {
        "title": "Interactive Activity",
        "url": "https://drive.google.com/drive/folders/10mIUpS-KqyqHi8eJGBL1rUGwGFIZFAQ-"
      },
      {
        "title": "Solving Video",
        "url": "https://drive.google.com/drive/folders/1r3HIpewugX4Za6XA-LtUPQ26OC8iw2PU"
      },
      {
        "title": "PowerPoint Notes",
        "url": "https://drive.google.com/drive/folders/1uE2wpHmWhdSTKn3--jmKlj9w13rNm6MJ"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Pend. Islam",
    "year": "Tahun 5",
    "items": [
      {
        "title": "Aktiviti Pembelajaran Abad ke-21",
        "url": "https://drive.google.com/drive/folders/143_qZOqHQiKcluatj29ABzwC4DStajDM"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1pI1XQhW1ls30SusoV0SSVzzq19FLuCjR"
      },
      {
        "title": "Modul Literasi dan Amali Sivik",
        "url": "https://drive.google.com/drive/folders/1PUMUI9GPXnNiVtplvndEobnj7nj3udFk"
      },
      {
        "title": "Modul Teknologi Maklumat dan Komunikasi (TMK)",
        "url": "https://drive.google.com/drive/folders/1we5JlhKTvXF4Z11H0kHeWLp2NMQyLxMS"
      },
      {
        "title": "Pembelajaran Berasaskan Projek (PBP)",
        "url": "https://drive.google.com/drive/folders/1c8SENj_YOVFjaf3lKD4xcTQYhGvG1DoY"
      },
      {
        "title": "Rekod Prestasi Murid",
        "url": "https://drive.google.com/drive/folders/14nuMzeHYDaXCNKqTy3mEQqCQQVqBGq5o"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1bfrynghmrYulzwEEjuPYitWdxtVrcFRZ"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Pend. Islam",
    "year": "Tahun 6",
    "items": [
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1Cyb4WFiP1jkwa5Hf7RRpTgxhSnQ0lESS"
      },
      {
        "title": "Modul Teknologi Maklumat dan Komunikasi (TMK)",
        "url": "https://drive.google.com/drive/folders/1y8-iH1SQk48vnDxUBh794uoYlnv4ut2Q"
      },
      {
        "title": "Aktiviti Pembelajaran Abad ke-21",
        "url": "https://drive.google.com/drive/folders/1WC-iazOF70VlBmJqxj3Kr-Sq7ZmiQqZ6"
      },
      {
        "title": "Rekod Prestasi Murid",
        "url": "https://drive.google.com/drive/folders/11rmuEX8HySMTPBZSGEx__8J09NvXeomn"
      },
      {
        "title": "Modul Literasi dan Amali Sivik",
        "url": "https://drive.google.com/drive/folders/1Lvyd2-dDlVVBXQMrLHcC_wOtPCg4auF-"
      },
      {
        "title": "Pembelajaran Berasaskan Projek (PBP)",
        "url": "https://drive.google.com/drive/folders/1dt8RtV9jLFsFihjZf_pVXBJAJMtj9nHq"
      },
      {
        "title": "Bidang Al-Quran",
        "url": "https://drive.google.com/drive/folders/1I8O9mIql400Us1emVFhTKptjR2bVOkc5"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/10sGwcYLx8DCQyC8wIQdJsuwn384KMMUl"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Pend. Islam",
    "year": "Tahun 4",
    "items": [
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1lh7HptLiAZPj3CnkLBBvfTHH_cwiyahP"
      },
      {
        "title": "Rekod Prestasi Murid",
        "url": "https://drive.google.com/drive/folders/1VUGNNUOrnTrQDswGp2VaAw18Gr03A1zx"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1pXlteGvTVfi4zgmBJZagLODDDl39UzS1"
      },
      {
        "title": "PAT",
        "url": "https://drive.google.com/drive/folders/1E_DXich6aKpMh8qETEDgsbvt4a9gn62j"
      }
    ]
  },
  {
    "book": "Smart PBD AI_PJPK",
    "year": "Tahun 6",
    "items": [
      {
        "title": "IFC ",
        "url": "https://drive.google.com/drive/folders/1vKYrGTeU12mpOo3Qq9pKEKRjWCrk_fsJ"
      },
      {
        "title": "IBC",
        "url": "https://drive.google.com/drive/folders/1R8E9J-gIwsrVOBfo6oS3TwEPXJJ0tMLp"
      },
      {
        "title": "AI +",
        "url": "https://drive.google.com/drive/folders/1OAQMCnM1I-bXtZ0fUOaccZ9Nja_y_-gg"
      }
    ]
  },
  {
    "book": "Smart PBD AI_PJPK",
    "year": "Tahun 5",
    "items": [
      {
        "title": "IFC",
        "url": "https://drive.google.com/drive/folders/1CECaqxZTfJLbpnqlaZ__t3-zFgOi2WZz"
      },
      {
        "title": "IBC",
        "url": "https://drive.google.com/drive/folders/1qDEvK2Ss6mayLVJ_tVGLRrVE0J9_z2J2"
      },
      {
        "title": "AI +",
        "url": "https://drive.google.com/drive/folders/1XADE8O8qApPLehKm1Jl14tHcuZ4mJh_n"
      }
    ]
  },
  {
    "book": "Smart PBD AI_PJPK",
    "year": "Tahun 4",
    "items": [
      {
        "title": "AI (author's link)",
        "url": "https://drive.google.com/drive/folders/1sLPufXkHQD9yTa057RTK0Hszrib5GMSJ"
      },
      {
        "title": "IFC",
        "url": "https://drive.google.com/drive/folders/19BbKgolXtgkHN1Q-pI1L4NQDExR7nIh_"
      },
      {
        "title": "IBC",
        "url": "https://drive.google.com/drive/folders/1FCNW4oqgC-YUULHdOenHUmEOnoCnuTLl"
      }
    ]
  },
  {
    "book": "Smart PBD AI_PJPK",
    "year": "Tahun 3",
    "items": [
      {
        "title": "IFC",
        "url": "https://drive.google.com/drive/folders/1T-E8_DAn7iKfwLl6f2Qx5aX4L7-SKH9l"
      },
      {
        "title": "IBC",
        "url": "https://drive.google.com/drive/folders/1RHC5hkEHGJb2viXjlzS2jcosEbfas-Yz"
      },
      {
        "title": "AI +",
        "url": "https://drive.google.com/drive/folders/1NxNZVotuV-tCBe6mbyBAL2xffD41hNi5"
      }
    ]
  },
  {
    "book": "Smart PBD AI_PJPK",
    "year": "Tahun 2",
    "items": [
      {
        "title": "IFC",
        "url": "https://drive.google.com/drive/folders/16DLzTI24D5jiRJkplYTuty4ie6n55Rxg"
      },
      {
        "title": "IBC",
        "url": "https://drive.google.com/drive/folders/1kwE8tjknrip6LW9IVbNVRe5bpcoSwVBA"
      },
      {
        "title": "AI +",
        "url": "https://drive.google.com/drive/folders/1t08hmFfYyUqZEQO8oNrRuH4CTyIZJg4L"
      }
    ]
  },
  {
    "book": "Smart PBD AI_PJPK",
    "year": "Tahun 1",
    "items": [
      {
        "title": "IFC   AI+",
        "url": "https://drive.google.com/drive/folders/1PMKfUSJlojJVrEs7UfaG1pvPznpJPS9Y"
      },
      {
        "title": "AI +",
        "url": "https://drive.google.com/drive/folders/1Mqfzz75dsffiu5UocoxDzNq6TGgfS5aB"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Muzik",
    "year": "Tahun 2",
    "items": [
      {
        "title": "IFC ",
        "url": "https://drive.google.com/drive/folders/1RZKq0BiVtjOcsq9CjOsGxSP_EHCNXYsH"
      },
      {
        "title": "IBC",
        "url": "https://drive.google.com/drive/folders/1UjWVBEM4H7v5O5a7dWWEB7WDPTzwat_V"
      },
      {
        "title": "AUDIO",
        "url": "https://drive.google.com/drive/folders/1ofbem8hXnM0n0H6tSwRvsJ7Vp5r0XAPw"
      },
      {
        "title": "AI +",
        "url": "https://drive.google.com/drive/folders/1_qx3q_jGrU_Bq2MKhb--2OOXB0SKOwPL"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Muzik",
    "year": "Tahun 3",
    "items": [
      {
        "title": "IFC ",
        "url": "https://drive.google.com/drive/folders/1Pp-WgcIMhLwvsUWBIfnza4kRblQ6XV-j"
      },
      {
        "title": "IBC",
        "url": "https://drive.google.com/drive/folders/1IdVvDWX_tkD9Fte-DCtFJfZlWRt455F7"
      },
      {
        "title": "AI +",
        "url": "https://drive.google.com/drive/folders/1dfBocy1DCDrftFx0G7Qq0n4xDps_uNAx"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Muzik",
    "year": "Tahun 4",
    "items": [
      {
        "title": "IFC ",
        "url": "https://drive.google.com/drive/folders/1GRfp1ETHe1xb8TOPBwCADX0_OUVkEAzj"
      },
      {
        "title": "IBC",
        "url": "https://drive.google.com/drive/folders/1ceTRfL_288PfWHnQIOwwIYISRZehBXVV"
      },
      {
        "title": "AUDIO",
        "url": "https://drive.google.com/drive/folders/1YSfX-2MdQ8HSr3mgeEoas5yS9kC5coFO"
      },
      {
        "title": "AI +",
        "url": "https://drive.google.com/drive/folders/1v4n_G0wqtrMMU5b_R9pvrn0G51UQbArs"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Muzik",
    "year": "Tahun 5",
    "items": [
      {
        "title": "IFC ",
        "url": "https://drive.google.com/drive/folders/1bCGbo5p5cGxm6PbH3D-PlTwLSajlUxUj"
      },
      {
        "title": "IBC",
        "url": "https://drive.google.com/drive/folders/1Rqk-HW18IV3dOWNjSr51qTVE3o9j-DSV"
      },
      {
        "title": "AI +",
        "url": "https://drive.google.com/drive/folders/11EHUlnNlOiE_77CnVU7L-4VWQBtXbvVV"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Muzik",
    "year": "Tahun 6",
    "items": [
      {
        "title": "IFC",
        "url": "https://drive.google.com/drive/folders/12Zs6F_DAFiWD2GVhMuXZrvcMJmnyKWM_"
      },
      {
        "title": "IBC",
        "url": "https://drive.google.com/drive/folders/1iztiyJWVbvAtFtP29R7Ou_SxiD2LKSjb"
      },
      {
        "title": "AI +",
        "url": "https://drive.google.com/drive/folders/1wTrL0yU0HyAB1ii1PYGxXRIMSCGcTArz"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Bhs. Melayu",
    "year": "Tahun 5",
    "items": [
      {
        "title": "BM Tahun 5 (Jawapan)",
        "url": "https://drive.google.com/drive/folders/1FaV1QLoVopfcfq4QfCXcwFjFOxv8opFZ"
      },
      {
        "title": "Elemen AI",
        "url": "https://drive.google.com/drive/folders/1MWLsVA179yHclGrrqou0sbAhnd26cxb5"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Bhs. Melayu",
    "year": "Tahun 6",
    "items": [
      {
        "title": "BM Tahun 6 (Jawapan)",
        "url": "https://drive.google.com/drive/folders/1k9NJ6WC41P2aBTut5d7q0GgiReSR3CjG"
      },
      {
        "title": "Elemen AI",
        "url": "https://drive.google.com/drive/folders/1YCtGt0k-QlMcc5LBtzSIZM2vAhTh0uDK"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Bhs. Melayu",
    "year": "Tahun 4",
    "items": [
      {
        "title": "BM Tahun 4 (Jawapan)",
        "url": "https://drive.google.com/drive/folders/1lHUrBnzBc7nYdEEr44CtnaqDeaweJ9Np"
      },
      {
        "title": "Elemen AI",
        "url": "https://drive.google.com/drive/folders/1VOBorbQh7vQ8jvqvSWDPXEnqFDwkhxwf"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Bhs. Arab",
    "year": "Tahun 5",
    "items": [
      {
        "title": "Rekod Prestasi Murid",
        "url": "https://drive.google.com/drive/folders/11-MRg5I3D3EhxwwCqWms6p7nmNILD2gr"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1ayWxuFuAnO2t5XzL-cI_zUiMVvxGMrIG"
      },
      {
        "title": "Unit 1",
        "url": "https://drive.google.com/drive/folders/1KBEwnfnbEJxcyi0wO59QK5WHJptlSm8F"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1UHN1QSWy0clAyMSMOOd9sBJiM7_KQRFn"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Bhs. Arab",
    "year": "Tahun 4",
    "items": [
      {
        "title": "Rekod Murid",
        "url": "https://drive.google.com/drive/folders/15G4C4W611rzXGa6b15I6f-83Q_DYo8Eb"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/12C_UVY-xcgjVOKrsH3Y7ouEKXHnhNIaQ"
      },
      {
        "title": "PAT",
        "url": "https://drive.google.com/drive/folders/1R0kHvJdsWltXLGBPruL3vCCCjrm2MhcM"
      },
      {
        "title": "Unit 1",
        "url": "https://drive.google.com/drive/folders/1U93swfFHdQRx9DGJz03fnjmLtbBs_kgJ"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1upDnQSpBXxd93Vs9VsB_lF_JQCxJssNY"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Bhs. Arab",
    "year": "Tahun 6",
    "items": [
      {
        "title": "Rekod Prestasi Murid",
        "url": "https://drive.google.com/drive/folders/1El5axTmWVOKhx9DO7zPI2YAxYu1CjRU3"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1Zf8rQBgyuBfvJL6UU_7sHtzNyB5EV-WK"
      },
      {
        "title": "Unit 1",
        "url": "https://drive.google.com/drive/folders/1Bt9n0pYr3yteXyG3nwRDy-pXgU0uAed5"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1XGcNcHFL7Qm2Y7Ee_JvWc-Lt2tdllJPz"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Matematik",
    "year": "Tahun 5",
    "items": [
      {
        "title": "Matematik Tahun 5 (Jawapan)",
        "url": "https://drive.google.com/drive/folders/1rOQavYxRrQYEbDeJaqhl2xdO0vBzR1L0"
      },
      {
        "title": "Baharu (IFC)",
        "url": "https://drive.google.com/drive/folders/1vygD7SSFuMZmq50jQnNnfOGM5U7d9R8P"
      },
      {
        "title": "Elemen AI",
        "url": "https://drive.google.com/drive/folders/1VFm2mq-4Ukyyr57LALX7i2CGIAOBw06Q"
      },
      {
        "title": "JSI Ujian Bulanan 2",
        "url": "https://drive.google.com/drive/folders/1V9F8nY0hmLvYC3abG5aNE4fSoeeQvher"
      },
      {
        "title": "JSI Ujian Bulanan 1",
        "url": "https://drive.google.com/drive/folders/1A_UrBMhVCgrRLoNNb1WHIyGVVRseSF9o"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Matematik",
    "year": "Tahun 6",
    "items": [
      {
        "title": "Matematik Tahun 6 (Jawapan)",
        "url": "https://drive.google.com/drive/folders/1LGEUDo1Z2DDsSry8sGsgMNeJgl_eEiOE"
      },
      {
        "title": "Baharu (IFC)",
        "url": "https://drive.google.com/drive/folders/1VbvhflnVSZ9jb-V1hiCGqU5W_w5H636B"
      },
      {
        "title": "JSI Ujian Bulanan 2",
        "url": "https://drive.google.com/drive/folders/1eYX07tWal5mAtqyRdJIOgJqcjYz-LBv1"
      },
      {
        "title": "JSI Ujian Bulanan 1",
        "url": "https://drive.google.com/drive/folders/1B-tK_yNu7UfQDc9-vOu4lLh2dfF4GodI"
      },
      {
        "title": "Elemen AI",
        "url": "https://drive.google.com/drive/folders/1TvHORZf-GnmqrRBH1poBJhdCjKlxi1xv"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Matematik",
    "year": "Tahun 4",
    "items": [
      {
        "title": "Matematik Tahun 4 (Jawapan)",
        "url": "https://drive.google.com/drive/folders/16znJnPta04Xxa4nouAkyRfj-Ess1O-VJ"
      },
      {
        "title": "Elemen AI",
        "url": "https://drive.google.com/drive/folders/1DtCBi8BTA47X-nGQD8vKccJtG1otEwHZ"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Sains",
    "year": "Tahun 6",
    "items": [
      {
        "title": "e-buku",
        "url": "https://drive.google.com/drive/folders/1oZ9HpPPtQp4Gh7MgsjFNOCNsUWasOqzg"
      },
      {
        "title": "UPSA",
        "url": "https://drive.google.com/drive/folders/1zbVXvao1m8Ub83XS13tmuDOm6cF49ja0"
      },
      {
        "title": "Sains Tahun 6 (Jawapan)",
        "url": "https://drive.google.com/drive/folders/1-s3j2CEKvcyKcXWdSi8-vty-Q0LQfxrV"
      },
      {
        "title": "Video Pengajaran",
        "url": "https://drive.google.com/drive/folders/1MX2ENqL8qEPQBf2q6OBqtWwO4YDX_EIz"
      },
      {
        "title": "Video Tutorial",
        "url": "https://drive.google.com/drive/folders/1oO614o69YgrUo9YmmUSjLhVMZ_btLBTp"
      },
      {
        "title": "Video",
        "url": "https://drive.google.com/drive/folders/1kMqjZrkd426Q7yvPyAftQLT60BlBhXr8"
      },
      {
        "title": "Aktiviti Interaktif",
        "url": "https://drive.google.com/drive/folders/1iHLuMRQtahr3_3zH9K5U01PN8uuvax-p"
      },
      {
        "title": "Elemen AI",
        "url": "https://drive.google.com/drive/folders/1cTPJ56kXHSE-h03PHPDHVR1QIYndfxMV"
      },
      {
        "title": "JSI Ujian Bulanan 2",
        "url": "https://drive.google.com/drive/folders/1rhZhxxCCQoZBmPFXCjJJjdkkumOIaSHe"
      },
      {
        "title": "JSI Ujian Bulanan 1",
        "url": "https://drive.google.com/drive/folders/1Ui5w5Y71hDJf7zeInfyrG-Ycd-oBZx2I"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Sains",
    "year": "Tahun 5",
    "items": [
      {
        "title": "JSI",
        "url": "https://drive.google.com/drive/folders/1CVNvvTx39kajGI8XHLQDyejoC982Ok03"
      },
      {
        "title": "e-buku",
        "url": "https://drive.google.com/drive/folders/1yx8j1pjIQtmrUtXiW0e8Q1GftFVdi3XI"
      },
      {
        "title": "Sains Tahun 5 (Jawapan)",
        "url": "https://drive.google.com/drive/folders/1TBoOLEQueZlmDLtDYoXk68rYB7HKoujF"
      },
      {
        "title": "New IFC",
        "url": "https://drive.google.com/drive/folders/13V-uhOGqN21edOkKWnF5QxvZg7W2Xigs"
      },
      {
        "title": "Elemen AI",
        "url": "https://drive.google.com/drive/folders/10UIKii2iIMez3sf8LUzYaYMBXZFePiWV"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Sains",
    "year": "Tahun 4",
    "items": [
      {
        "title": "e-buku",
        "url": "https://drive.google.com/drive/folders/1GCnCJRfptqhNdQTtOEYQbwOJrYZ_9xe_"
      },
      {
        "title": "Sains Tahun 4 (Jawapan)",
        "url": "https://drive.google.com/drive/folders/1xRwG5mUlYCZgwhsS3LTNLz36uZFOvkTI"
      },
      {
        "title": "Aktiviti Pembelajaran Abad ke-21",
        "url": "https://drive.google.com/drive/folders/1IfUO4cFNz1eyVHUBibEGMpxY8Vn2Jz1S"
      },
      {
        "title": "Modul Teknologi Maklumat dan Komunikasi (TMK)",
        "url": "https://drive.google.com/drive/folders/1BGtq2ncXNvmO3UTlF92VJoD-wdpEgytQ"
      },
      {
        "title": "Pembelajaran Berasaskan Projek",
        "url": "https://drive.google.com/drive/folders/1gf_pW_5J39lpF2dvc9OYi3Ls4bL676aM"
      },
      {
        "title": "Elemen AI",
        "url": "https://drive.google.com/drive/folders/1dxIJLvf0OHsZqJnjbYAPRWz8zmJQ_KGq"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Jawi",
    "year": "Tahun 3",
    "items": [
      {
        "title": "Rekod Prestasi Murid",
        "url": "https://drive.google.com/drive/folders/15_KK-73pVVAKFmM8eQdXG-qvJkboDh5f"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1PC6QcoAyeD-ap3sZfOM6I9uuKSWYftiW"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/198HoRtpcQ-0kHlowztyx6eou01aJB75z"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Jawi",
    "year": "Tahun 5",
    "items": [
      {
        "title": "Rekod Prestasi Murid",
        "url": "https://drive.google.com/drive/folders/1DyX6RRWCSiODcM9gNTF7mfudxVtF1HIe"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1PcJtNiEoN87duMAzqnnycNdue3yRWgWg"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1G_lGm9yqA_urY8fiQfVNJdC5kaDRBvxW"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Jawi",
    "year": "Tahun 4",
    "items": [
      {
        "title": "Rekod Murid",
        "url": "https://drive.google.com/drive/folders/1qBCuV5bbS3-81gfoNpgp48bBdnerzh4r"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1m90owZHrQMg0Wlfs5zAdNfpDJBddSiq5"
      },
      {
        "title": "Video Pengajaran",
        "url": "https://drive.google.com/drive/folders/1cciRt7ckIR4LxLQnuCm8ME7gw7fOoFte"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1qNyuq75NZMUpmq8u8q2XqjsGvby5iO4S"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Jawi",
    "year": "Tahun 2",
    "items": [
      {
        "title": "Rekod Prestasi Murid",
        "url": "https://drive.google.com/drive/folders/1bNv5sQF9IWysHRuUy_59k5eQcHRib-Ht"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1C8hetj9q_HTzAiCYfAgtJHcVnNO3mh6K"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1S9RhOHZc-sUpcEeYyN1v0teLUtctrFCb"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Jawi",
    "year": "Tahun 6",
    "items": [
      {
        "title": "Rekod Prestasi Murid",
        "url": "https://drive.google.com/drive/folders/1s9-dhxmoDDa7pzq1_DQrXc8Edn3h0wT3"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1ZbM_EgFT0BR2KFHaiXcesmie94hehLvV"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/19sk7UczedykNobgWLHi53V3HPGoiQtDc"
      }
    ]
  },
  {
    "book": "Smart PBD AI_RBT",
    "year": "Tahun 5",
    "items": [
      {
        "title": "Rekod Murid",
        "url": "https://drive.google.com/drive/folders/1U7_QLFXwSBB6tblfMrZNP5IrnhA-zX1T"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1GXHalhRFwl6v_vxMb5_8gv8cVQAaH14c"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1gKfrVvuixk4kQ7AknXqjG7Yt6lgo1RxV"
      }
    ]
  },
  {
    "book": "Smart PBD AI_RBT",
    "year": "Tahun 4",
    "items": [
      {
        "title": "Video Pengajaran",
        "url": "https://drive.google.com/drive/folders/1jNt0yQsBAUX81vxq0QTYXI9wv5p74pch"
      },
      {
        "title": "Rekod Murid",
        "url": "https://drive.google.com/drive/folders/1VZwX4UMvViWWuLXHDKLG-lFH4ySTJ0NX"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1naOvU5r70Ua34Gdta0h0UQwVfwxQ3cSp"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1xDSd4FmApu5ycfMBhZSOT6sIvJOjbdod"
      }
    ]
  },
  {
    "book": "Smart PBD AI_RBT",
    "year": "Tahun 6",
    "items": [
      {
        "title": "Rekod Murid",
        "url": "https://drive.google.com/drive/folders/1JOagQ8KaUR_b2OLpnswWty7Y_o4Eo-og"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1WZGOUHPVaex31RYRLIDvY3xM1Obqaaxm"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1rIEwfRloI1Wn-S4MhH488MfvlkYdDFGT"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Sejarah",
    "year": "Tahun 6",
    "items": [
      {
        "title": "Senarai Kuiz",
        "url": "https://drive.google.com/drive/folders/1yzRnVqnPjbN7HRQsoWIOZ5Og6uVASTx1"
      },
      {
        "title": "Senarai Praktis Ekstra",
        "url": "https://drive.google.com/drive/folders/1QxYq9XbCJ4fGOzEOuIGBrOZleZsCSkYd"
      },
      {
        "title": "Senarai Laman Web",
        "url": "https://drive.google.com/drive/folders/17H3j9PT-BhwTDMWR_JjrwzpIl26gwbyw"
      },
      {
        "title": "Senarai Video Tutorial",
        "url": "https://drive.google.com/drive/folders/1-Lv50iYwhILCltiKJFQqVQL5eiMMqQuF"
      },
      {
        "title": "Senarai Aktiviti Interaktif",
        "url": "https://drive.google.com/drive/folders/1mBC_eNhTJRCx1Q4fGxtba_vzegqb6tJx"
      },
      {
        "title": "JSI",
        "url": "https://drive.google.com/drive/folders/1E43F2Tl1CjqteFRL-Nw2USGjeBP2dJ3W"
      },
      {
        "title": "Pand. Guru",
        "url": "https://drive.google.com/drive/folders/1Ld_WmFaKZtndJzn8if_cQI8GU8NqD1sM"
      },
      {
        "title": "e-buku",
        "url": "https://drive.google.com/drive/folders/1rQfiGWIHBDyF3Mjsh8UGoiW1UHiPqfzg"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1C2nG3_qIOdxQBmgzkcvgPAvXUKpnzkX7"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1EYuM5HOvvIjxXHmwWIE7d0StGcUBnFp6"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Sejarah",
    "year": "Tahun 4",
    "items": [
      {
        "title": "JSI",
        "url": "https://drive.google.com/drive/folders/1Ac1kwP-xzPZ2_mFeZYvmW7O7_qHaj3Lm"
      },
      {
        "title": "Pand. Guru",
        "url": "https://drive.google.com/drive/folders/1JFSi4E7hTmZZcIywctRnTosBxxNh-uSE"
      },
      {
        "title": "e-buku",
        "url": "https://drive.google.com/drive/folders/1jfzPAt22R9Awndfo1feNZzHY_WFUu6UB"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/10rlyOwZsoJhck4kp1fcaiI-b3G-LTn5r"
      },
      {
        "title": "Unit 2",
        "url": "https://drive.google.com/drive/folders/12Vt2rvzzWPsFBMWkM6HpsG2NpwkoFDaT"
      },
      {
        "title": "Unit 1",
        "url": "https://drive.google.com/drive/folders/1s8VkaZg5QfnooSJFFTB9Ay5BlATRgT4-"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1VfwT18cxmEvnHRsRoKIupKBgILoHNK46"
      }
    ]
  },
  {
    "book": "Smart PBD AI_Sejarah",
    "year": "Tahun 5",
    "items": [
      {
        "title": "Senarai Video",
        "url": "https://drive.google.com/drive/folders/18aw2U6HZ9C3amCpqsZgx6pir85G-u3n7"
      },
      {
        "title": "Senarai Video Tutorial",
        "url": "https://drive.google.com/drive/folders/182obC_-uiiB_BRjx1MJNgCWAn8ZB4PY3"
      },
      {
        "title": "Senarai Praktis Ekstra",
        "url": "https://drive.google.com/drive/folders/14_UbLnYevG9_r3smE1Od8bN-61Krkzr6"
      },
      {
        "title": "JSI",
        "url": "https://drive.google.com/drive/folders/1N72uSXpbbvBgWosrhgq1URmF3-_ArSPw"
      },
      {
        "title": "Pand. Guru",
        "url": "https://drive.google.com/drive/folders/1MAN9wgooZxnL7u_SEeW7xOIdIGDV7O2c"
      },
      {
        "title": "e-buku",
        "url": "https://drive.google.com/drive/folders/1BpfPqtj40VBBi7KzPeXr2ydu-pvXUoTT"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1vsSdqAd0pXbLx0XpdsTn1L8N-Pr2LrQ7"
      },
      {
        "title": "AI",
        "url": "https://drive.google.com/drive/folders/1yEEw1ccrIaCVF7pSuC-96xg93InQfXle"
      }
    ]
  },
  {
    "book": "Smart AI PBD PSV Tahun 1-6",
    "year": "PSV Tahun 4",
    "items": [
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1SHUQW3ybWr8oPHe8a6wV6w5sFGQTjgVu"
      },
      {
        "title": "Video Tutorial",
        "url": "https://drive.google.com/drive/folders/1F54yhH3w1i699EU3sJxUs3abQ8X3lSjb"
      }
    ]
  },
  {
    "book": "Smart AI PBD PSV Tahun 1-6",
    "year": "PSV Tahun 6",
    "items": [
      {
        "title": "Video Tutorial",
        "url": "https://drive.google.com/drive/folders/1ZR2jzKq4Szj2EdIiOqB-8hHDmSZAV6PJ"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1UcuYsEEHBORT9RJWf88Zm03p-iMPXGz6"
      }
    ]
  },
  {
    "book": "Smart AI PBD PSV Tahun 1-6",
    "year": "PSV Tahun 2",
    "items": [
      {
        "title": "Video Tutorial",
        "url": "https://drive.google.com/drive/folders/1AvoJe0TGPHhHmxlQcGDTsmM1WDGDUFZe"
      }
    ]
  },
  {
    "book": "Smart AI PBD PSV Tahun 1-6",
    "year": "PSV Tahun 5",
    "items": [
      {
        "title": "Video Tutorial",
        "url": "https://drive.google.com/drive/folders/17Y5zFgAOnAIayDhmY5lqzpJ_Wz51xzby"
      },
      {
        "title": "Jawapan",
        "url": "https://drive.google.com/drive/folders/1fAck8EpmCbW79MaYanFeV3kfh3wY-G_0"
      }
    ]
  },
  {
    "book": "Smart AI PBD PSV Tahun 1-6",
    "year": "PSV Tahun 3",
    "items": [
      {
        "title": "Bahan AI",
        "url": "https://drive.google.com/drive/folders/1GiQndrdjLtIA6Ne6lgHW4xF1llYcxsqG"
      },
      {
        "title": "Kod QR (Video Tutorial)",
        "url": "https://drive.google.com/drive/folders/1hd2yK3-b4-L2K3bTHqYjsRsfck4D_Zeh"
      }
    ]
  }
];
